import {createPinia} from "pinia";
import {createORM, useRepo} from "pinia-orm";
import {createPiniaOrmAxios} from "@pinia-orm/axios";
import axios from "axios";
import { createApp } from "vue";
import {createBootstrap} from "bootstrap-vue-next";
import UrlManager from "@/components/plugins/url-manager.js";

export function initPinia() {

    const pinia = createPinia();
    const pinia_orm = createORM( {
        plugins: [
            createPiniaOrmAxios( {
                axios,
            } ),
        ],
    } );
    pinia.use( pinia_orm );

    return pinia;
}

export function initWidget( selector, widget ) {

    document.addEventListener( 'DOMContentLoaded', () => {

        const elements = document.querySelectorAll( selector );
        if ( !elements.length ) {
            console.error( `No elements found with selector "${ selector }"` );
            return;
        }

        // Create a map of available model files using import.meta.glob
        const modelFiles = import.meta.glob( '../models/*.js' );

        elements.forEach( ( div ) => {
            const props = JSON.parse( div.getAttribute( 'data-vue-props' ) || '{}' );
            const provides = JSON.parse( div.getAttribute( 'data-vue-provides' ) || '{}' );
            const models = JSON.parse( div.getAttribute( 'data-vue-models' ) || '[]' );

            console.log( 'app props', props );
            console.log( 'app provides', provides );
            console.log( 'app models', models );

            const app = createApp( widget, props );

            for ( const name in provides ) {
                app.provide( name, provides[ name ] );
            }

            app.use( initPinia() );
            app.use( createBootstrap() );

            if ( window.PARAMS ) {
                app.use( UrlManager, {
                    base_url: window.PARAMS.base_url,
                    controller_id: window.PARAMS.controller_id,
                    action_id: window.PARAMS.action_id
                } );
            } else {
                console.error( 'window.PARAMS is missing.' );
            }

            // Load models dynamically
            const promises = models.map( ( modelDef ) => {
                const type = modelDef.type;
                const relPath = `../models/${ type }.js`;

                const importer = modelFiles[ relPath ];

                if ( !importer ) {
                    console.error( `Model file not found: ${ relPath }` );
                    return Promise.resolve(); // Don't block other models
                }

                return importer().then( ( { default: model } ) => {
                    useRepo( model ).save( modelDef.data );
                } );
            } );

            Promise.all( promises ).then( () => {
                app.mount( div );
            } );
        } );
    } );
}